export default "__VITE_ASSET__cea9e670__"